/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

/**
 * Creates a sorting function based on a priority map.
 * Items with relationshipIds present in the priorityMap will be sorted
 * according to their mapped priority values. Items with relationshipIds
 * not present in the map will be assigned a default priority.
 * @param propertyName
 * @param preferredOrder
 * @param defaultOrder
 * @returns {function(*, *): *}
 */

export const sortByPropertyOrder = (propertyName, preferredOrder = null, defaultOrder = null) => {
    const getPriority = (value) => {
        // if no priority array is provided, sort by the value itself
        if(!preferredOrder) { return value; }
        
        // otherwise, sort by the index of the value in the priority array
        const index = preferredOrder.indexOf(value);
        return index !== -1 ? index : (defaultOrder ?? preferredOrder.length);
    };
    return (a, b) => getPriority(a[propertyName]) - getPriority(b[propertyName]);
};
